// Thanh "Có bản cập nhật mới · Tải lại" — hiện khi service worker bản mới đã tải xong và
// đang chờ (xem src/swUpdate.js). Cố định đáy màn hình, không tự reload.
import { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import { useTranslation } from 'react-i18next';

import { applyUpdate, subscribeUpdate } from '@app/swUpdate';

import './UpdatePrompt.scss';

export const UpdatePrompt = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeUpdate(() => setVisible(true)), []);

  if (!visible) return null;

  return (
    <div className="sw-update" role="status" data-testid="sw-update">
      <span className="sw-update-msg">{t('swUpdate.message')}</span>
      <Button size="small" color="primary" onClick={applyUpdate} data-testid="sw-update-reload">
        {t('swUpdate.reload')}
      </Button>
    </div>
  );
};

export default UpdatePrompt;
